import { render, staticRenderFns } from "./create_v1.vue?vue&type=template&id=f240d518&scoped=true&"
import script from "./create_v1.vue?vue&type=script&lang=js&"
export * from "./create_v1.vue?vue&type=script&lang=js&"
import style0 from "./create_v1.vue?vue&type=style&index=0&id=f240d518&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f240d518",
  null
  
)

export default component.exports